import React from "react";

import classes from "./AttributionsComp.module.css";

export default function AttributionsComp() {
  return (
    <div className={classes.generalStyle}>
      <a href="https://www.flaticon.com/free-icons/rose" title="rose icons">
        Rose icons created by Freepik - Flaticon
      </a>
    </div>
  );
}
